import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { RequestService } from '../../../core/services/request.service';

@Injectable()
export class DetailsService {

  constructor(
    private requestService: RequestService
  ) { }

  getDictionary(url: string): Observable<any> {
    return this.requestService.get(url)
        .map(res => this.extractData(res) );
  }
  getAmberDictionary(url: string): Observable<any> {
    return this.requestService.get(url, {verbose: true})
        .map(res => this.extractData(res) );
  }

  private extractData(res) {
    let data = res.data;
    return data;
  }
  refreshData(url: string): Observable<any> {
    return this.requestService.get(url);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/details/details.service.ts